import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map, shareReplay } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { FormationCementCatalog } from "../../models/formations-cement-catalog.model";
import { CatalogFilterMode } from '../../models/catalog-scope.enum';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api/formationCementCatalog/`;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class FormationsService {
  private formationCementCache$: Observable<FormationCementCatalog[]> | null = null;
  private lastFilter: CatalogFilterMode | null = null;

  constructor(private http: HttpClient) { }

  public getFormationCement(filter: CatalogFilterMode = CatalogFilterMode.AllItems): Observable<FormationCementCatalog[]> {
    // Clear cache if filter changed
    if (this.lastFilter !== filter) {
      this.formationCementCache$ = null;
      this.lastFilter = filter;
    }
    
    if (!this.formationCementCache$) {
      this.formationCementCache$ = this.http
        .get<FormationCementCatalog[]>(`${PeriforApiEndpoint}`, {
          params: { filter: filter }
        })
        .pipe(
          map(data => data.map(item => new FormationCementCatalog(item))),
          catchError(() => of([])),
          shareReplay(1)
        );
    }
    setTimeout(() => this.formationCementCache$ = null, 1000);
    return this.formationCementCache$;
  }

  addItem(model: FormationCementCatalog): Observable<{id: string}> {
    return this.http.post<{id: string}>(`${PeriforApiEndpoint}`, model);
  }

  updateItem(model: FormationCementCatalog): Observable<boolean> {
    return this.http.put<boolean>(`${PeriforApiEndpoint}${model.id}`, model, httpOptions);
  }

  deleteItem(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${PeriforApiEndpoint}${id}`);
  }
}
